import { SxProps, Theme } from '@mui/material/styles';

export const appleFontStack =
  "'SF Pro Display', 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif";

export const textScale = {
  hero: {
    fontWeight: 700,
    fontSize: 'clamp(2.75rem, 4vw, 3.9rem)',
    lineHeight: 1.1,
    letterSpacing: '-0.015em',
  },
  headline: {
    fontWeight: 600,
    fontSize: 'clamp(1.85rem, 2.5vw, 2.4rem)',
    lineHeight: 1.18,
    letterSpacing: '-0.01em',
  },
  body: {
    fontWeight: 400,
    fontSize: 'clamp(1rem, 0.6vw + 0.85rem, 1.15rem)',
    lineHeight: 1.6,
    letterSpacing: '0em',
  },
  support: {
    fontWeight: 400,
    fontSize: 'clamp(0.9rem, 0.4vw + 0.65rem, 0.98rem)',
    lineHeight: 1.5,
    letterSpacing: '0.01em',
  },
};

const horizontalPadding = { xs: 2, sm: 3, md: 5 };
const verticalPadding = { xs: 5, sm: 7, md: 9 };

export const sectionPadding = {
  px: horizontalPadding,
  py: verticalPadding,
};

export const blockPadding = {
  px: { xs: 2.5, md: 4 },
  py: { xs: 3, md: 4 },
};

export const sectionContainerSx: SxProps<Theme> = {
  ...sectionPadding,
  width: '100%',
  mx: 'auto',
  maxWidth: 'min(1400px, 100%)',
};

export const sectionStackGap = { xs: 4, md: 5 };
